import { POST,postFile,postBlob } from "../../index";

export const getImage = (param) => postBlob("/v1/FileController/getImage", param);
export const upload = (param) => postFile("/v1/FileController/upload", param);
export const uploadContractFile = (param) => postFile("/v1/FileController/uploadFile", param);
export const getFile = (param) => POST("/v1/FileController/getFile", param);

